import SmallTablePlaceholder from "../SmallTablePlaceholder";
import { useStyles } from "./styles";

import { Add, Check, Create } from "@mui/icons-material";
import { Dialog, IconButton } from "@mui/material";
import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { PosContext } from "../../shared/PosContext";
import CustomerCreationWizard from "../Customer/CustomerCreationWizard";
import reservedTableIcon from "./../../images/table-reserved-icon.svg";
import SimpleWidgetsInput from "../SimpleWidgetsInput/SimpleWidgetsInput";

const ReserveTableWidget = ({
    onConfirm,
    isLoading,
    selectedTable,
    backCallback,
    preSelectedCustomer,
}) => {
    const classes = useStyles();

    const { customers, refetchCustomers } = useContext(PosContext);

    const tables = [
        {
            name: selectedTable.tableDescription,
            reserved: selectedTable.reserved,
            identifier: selectedTable.name,
            numberOfSeats: selectedTable.numberOfSeats,
            numberOfOrders: selectedTable.numberOfOrders,
            floor: "1",
            actions: [],
            canDoBack: true,
        },
    ];

    const [filteredCustomerList, setFilteredCustomerList] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [createCustomerDialogOpen, setCreateCustomerDialogOpen] =
        useState(false);

    const handleChange = (value) => {
        setSelectedCustomer(null);
        if (value && value.length > 0) {
            setSearchText(value);
        } else {
            setSearchText("");
        }
    };

    useEffect(() => {
        if (customers) {
            if (selectedCustomer && selectedCustomer === searchText) {
                const newFilteredList = [...customers];
                setFilteredCustomerList(
                    newFilteredList.filter((customer) =>
                        customer.name
                            .toLocaleLowerCase()
                            .includes(searchText.toLocaleLowerCase())
                    )
                );
            } else {
                setFilteredCustomerList(customers);
            }
        }
    }, [customers]);

    useEffect(() => {
        if (customers) {
            const newFilteredList = [...customers];
            if (searchText) {
                setFilteredCustomerList(
                    newFilteredList.filter(
                        (customer) =>
                            customer.name
                                .toLocaleLowerCase()
                                .includes(searchText.toLocaleLowerCase()) ||
                            customer.mobile_no?.includes(searchText)
                    )
                );
            } else {
                setFilteredCustomerList(newFilteredList);
            }
        }
    }, [searchText]);

    useEffect(() => {
        if (preSelectedCustomer && preSelectedCustomer.length > 0) {
            setSearchText(preSelectedCustomer);
            setSelectedCustomer(preSelectedCustomer);
        }
    }, [preSelectedCustomer]);

    const setCustomer = (customer) => {
        setSelectedCustomer(customer.name);
    };

    const onCloseCreateCustomer = () => {
        setCreateCustomerDialogOpen(false);
    };

    const handleBackCallBack = () => {
        if (backCallback) {
            backCallback();
        }
    };

    const handleCustomerCreated = (customerData) => {
        refetchCustomers();
        setSearchText(customerData.data.name);
        setSelectedCustomer(customerData.data.name);
    };

    return (
        <div className={classes.ReserveTableWidget}>
            <div className={classes.SmallTablePlaceholderWrapper}>
                <SmallTablePlaceholder
                    icon={reservedTableIcon}
                    tables={tables}
                    backCallback={handleBackCallBack}
                />
            </div>

            <SimpleWidgetsInput
                label="Customer"
                isSearch
                value={searchText}
                placeholder="Search by name or phone #"
                onChange={handleChange}
                ActionIcon={Create}
                onActions={() => setCreateCustomerDialogOpen(true)}
            />
           
            <div className={classes.Customers}>
                <div className="Customers__Title">
                    {customers?.length} results found
                </div>
                <div
                    className="Customers__List"
                    style={{
                        maxHeight: "50vh",
                        height: "auto",
                        overflowY: "auto",
                    }}
                >
                    {filteredCustomerList.length > 0 ? (
                        filteredCustomerList.map((customer) => (
                            <div
                                key={customer.name}
                                onClick={() => setCustomer(customer)}
                                className={
                                    selectedCustomer === customer.name
                                        ? "selected"
                                        : ""
                                }
                            >
                                <div>
                                    <div>{customer.name}</div>
                                    <div className="subtext">
                                        {customer.mobile_no}
                                    </div>
                                </div>
                                {selectedCustomer &&
                                    selectedCustomer === customer.name && (
                                        <Check />
                                    )}
                            </div>
                        ))
                    ) : (
                        <p></p>
                    )}
                </div>
            </div>
            <div className={classes.Actions}>
                <button
                    className={classes.BtnSearch}
                    onClick={() => onConfirm(selectedCustomer)}
                >
                    <span className="IconWrap">
                        <i className="bx bx-plus"></i>
                    </span>
                    <span>Confirm reservation</span>
                </button>
            </div>
            <div>&nbsp;</div>
            <Dialog open={createCustomerDialogOpen}>
                <CustomerCreationWizard
                    onClose={onCloseCreateCustomer}
                    onConfirm={handleCustomerCreated}
                />
            </Dialog>
        </div>
    );
};

export default ReserveTableWidget;
